// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dz9BM{display:grid;grid-template-columns:repeat(auto-fit, minmax(200px, 1fr));gap:16px}.auhKl{text-align:left;border-radius:8px}.pzERJ{display:flex;flex-direction:column;align-items:flex-start;text-align:start;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dz9BM`,
	"card": `auhKl`,
	"cardContent": `pzERJ`
};
export default ___CSS_LOADER_EXPORT___;
